import { z } from 'zod';
import { getContextProviderExtensionsDir } from '@wix/cli-astro-definitions';
import {
  pathAvailableValidation,
  VALID_PATH_REGEX,
} from '../../../dev-center/components/validations/common.js';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateContextProvider } from './generate.js';

const schema = z.object({
  extensionType: z.literal('CONTEXT_PROVIDER'),
  name: z.string().describe(defineField({ title: 'Provider name' })),
  folder: z
    .string()
    .regex(VALID_PATH_REGEX)
    .describe(
      defineField({
        title: 'Provider folder',
        description: 'Lowercase alphanumeric, hyphens, and slashes',
      })
    ),
  type: z
    .string()
    .min(1)
    .describe(
      defineField({
        title: 'Provider type',
        description:
          'The context provider type suffix. The project code identifier is prepended automatically.',
      })
    ),
});

export const contextProvider: ExtensionDef<typeof schema> = {
  title: 'Context Provider',
  description: 'An experimental React context provider',
  group: 'Site',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const isAvailable = pathAvailableValidation(
      getContextProviderExtensionsDir(projectFolder)
    )(data.folder);
    return isAvailable
      ? null
      : 'The context provider folder must be unique, please choose a folder that has not been used yet in your application.';
  },
  generate: ({ projectFolder, model, data }) =>
    generateContextProvider(
      projectFolder,
      data.folder,
      data.name,
      data.type,
      model.config.projectType === 'App'
        ? model.config.codeIdentifier
        : undefined
    ),
};
